import type { MenuProps } from "antd";
import type { ReactNode } from "react";

import SecondaryActions from "@/components/Header/SecondaryActions/SecondaryActions";

export interface HeaderButtonListProps {
  primaryActions?: ReactNode[];
  secondaryActions?: MenuProps["items"];
}

const HeaderButtonList = ({
  primaryActions = [],
  secondaryActions = [],
}: HeaderButtonListProps) => {
  const headerButtons = [...primaryActions];

  if (secondaryActions.length) {
    headerButtons.push(
      <SecondaryActions key="secondaryActions" items={secondaryActions} />
    );
  }

  return <>{headerButtons}</>;
};

export default HeaderButtonList;
